import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import FormGroup from 'react-bootstrap/FormGroup';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Loader from '../../Common/Loader/Loader';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import RadioFieldComponent from '../../Common/RadioFieldComponent/RadioFieldComponent';

import { getBookingCancelReason } from '../../../lib/graphql';
import messages from '../../../locale/messages';
import validate from './validate';
import submit from './submit';
import { closeCancelScheduledBookingModal } from '../../../actions/siteadmin/modalActions';
import { withQuery } from '../../../hoc/withGraphql';

import bt from '../../../components/commonStyle.css';
import s from '../CancelBookingModal.css';


class CancelBookingForm extends Component {

    componentDidMount() {
        const { change, userType, cancelBookingData } = this.props;
        change('reason', 'other');
        change('requestBy', userType == 2 ? 'cancelledByPartner' : 'cancelledByUser');
        change('userType', userType);
        change('bookingId', cancelBookingData?.bookingId);
        change('status', cancelBookingData?.status);
    }

    handleClose = () => {
        const { status, closeCancelScheduledBookingModal, closeCancelBookingModal } = this.props;
        status !== 'scheduled' ? closeCancelBookingModal() : closeCancelScheduledBookingModal()
    }

    render() {
        const { userType, data: { getBookingCancelReason, loading }, reason } = this.props;
        const { submitLoading, submitting, status } = this.props;
        const { handleSubmit } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <form onSubmit={handleSubmit(submit)}>
                    {loading && status !== 'scheduled' && <div className={bt.spaceTop3}><Loader type="circle" show={loading} /></div>}
                    {status !== 'scheduled' && !loading &&
                        <div>
                            <div className={s.cancelBookingRatioList}>
                                {
                                    getBookingCancelReason?.results?.map((item, index) => {
                                        return (
                                            <RadioFieldComponent
                                                key={index}
                                                name="reason"
                                                size={18}
                                                isTick
                                                value={item.reason}
                                                label={item.reason}
                                                containerClassName={s.cancelRadioFlex} />
                                        )
                                    })
                                }

                                <RadioFieldComponent
                                    name="reason"
                                    value={"other"}
                                    size={18}
                                    isTick
                                    label={'Other'}
                                    containerClassName={s.cancelRadioFlex} />
                            </div>

                            {
                                reason === 'other' &&
                                <Field name="otherReason"
                                    type="text"
                                    component={InputFieldComponent}
                                    componentClass="textarea"
                                    placeholder={formatMessage(messages.otherReasons)}
                                    inputClass={bt.formTextArea} />
                            }
                        </div>}
                    {
                        (!loading || status == 'scheduled') && <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                            <Button onClick={() => this.handleClose()} className={bt.btnSecondary}>{formatMessage(messages.close)}</Button>
                            <Loader
                                type={"button"}
                                buttonType={"submit"}
                                show={submitLoading}
                                disabled={submitting || submitLoading}
                                label={formatMessage(messages.proceed)}
                                className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                            />

                        </div>
                    }

                </form >
            </div >
        )
    }
}

CancelBookingForm = reduxForm({
    form: 'CancelBookingForm',
    validate
})(CancelBookingForm);

const selector = formValueSelector('CancelBookingForm');

const mapState = (state) => ({
    reason: selector(state, 'reason'),
    status: selector(state, 'status'),
    submitLoading: selector(state, 'loading'),
    cancelBookingData: state?.adminModalStatus?.cancelData,
})

const mapDispatch = {
    closeCancelScheduledBookingModal
}

export default compose(
    injectIntl,
    withStyles(bt, s),
    connect(mapState, mapDispatch),
    withQuery(getBookingCancelReason, {
        options: (props) => ({
            variables: {
                userType: Number(props.userType) || 1
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    })
)(CancelBookingForm);